module.exports = "/_next/static/images/5894310b028991e2b0bfa298899eae4c-cajitas-right-desktop.jpg.webp";